import React from "react";
import { Link } from "react-router-dom";
import { Phone, Menu, X } from "lucide-react";

const PHONE = "01.84.16.20.60";
const PHONE_TEL = "tel:+33184162060";
const LOGO =
  "https://static.prod-images.emergentagent.com/jobs/43781dee-f402-4763-b282-7ff328abc859/images/bffb0cad70b3e8a822351e5071db4d080560e768a973767a735abe6e67837c16.png";

export const Header = () => {
  const [open, setOpen] = React.useState(false);
  return (
    <header className="sticky top-0 z-50 bg-white/85 backdrop-blur-xl border-b border-slate-200/60">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-20 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3" data-testid="header-logo-link">
          <img src={LOGO} alt="Logo Débouchage canalisation 93" className="h-12 w-auto" />
          <div className="hidden sm:block leading-tight">
            <div className="font-black tracking-tight text-[#0F172A] text-lg" style={{ fontFamily: "'Cabinet Grotesk', 'Manrope', sans-serif" }}>
              Débouchage
            </div>
            <div className="text-[10px] uppercase tracking-[0.25em] text-[#FF5A1F] font-bold">
              Canalisation 93
            </div>
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-7 text-sm font-semibold text-slate-700">
          <Link to="/" className="hover:text-[#FF5A1F] transition" data-testid="nav-accueil">Accueil</Link>
          <a href="/#services" className="hover:text-[#FF5A1F] transition" data-testid="nav-services">Services</a>
          <a href="/#zones" className="hover:text-[#FF5A1F] transition" data-testid="nav-zones">Villes</a>
          <a href="/#avis" className="hover:text-[#FF5A1F] transition" data-testid="nav-avis">Avis</a>
          <a href="/#faq" className="hover:text-[#FF5A1F] transition" data-testid="nav-faq">FAQ</a>
          <a href="/#contact" className="hover:text-[#FF5A1F] transition" data-testid="nav-contact">Contact</a>
        </nav>

        <a
          href={PHONE_TEL}
          data-testid="header-call-btn"
          className="hidden sm:inline-flex items-center gap-2 bg-[#FF5A1F] hover:bg-[#E04812] text-white font-extrabold px-5 py-3 rounded-full shadow-md transition-all hover:-translate-y-0.5"
        >
          <Phone className="w-4 h-4" strokeWidth={2.5} />
          <span className="tracking-tight">{PHONE}</span>
        </a>

        <button
          className="sm:hidden p-2 text-slate-900"
          onClick={() => setOpen((v) => !v)}
          data-testid="mobile-menu-toggle"
          aria-label="Menu"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {open && (
        <div className="sm:hidden border-t border-slate-200 bg-white px-4 py-4 flex flex-col gap-3 text-sm font-semibold text-slate-800">
          <Link onClick={() => setOpen(false)} to="/" data-testid="mobile-nav-accueil">Accueil</Link>
          <a onClick={() => setOpen(false)} href="/#services" data-testid="mobile-nav-services">Services</a>
          <a onClick={() => setOpen(false)} href="/#zones" data-testid="mobile-nav-zones">Villes</a>
          <a onClick={() => setOpen(false)} href="/#avis" data-testid="mobile-nav-avis">Avis</a>
          <a onClick={() => setOpen(false)} href="/#faq" data-testid="mobile-nav-faq">FAQ</a>
          <a
            href={PHONE_TEL}
            className="mt-2 inline-flex items-center justify-center gap-2 bg-[#FF5A1F] text-white font-extrabold px-5 py-3 rounded-full"
            data-testid="mobile-call-btn"
          >
            <Phone className="w-4 h-4" /> {PHONE}
          </a>
        </div>
      )}
    </header>
  );
};

export default Header;
